import React from 'react';
import { trashOutline } from 'ionicons/icons';
import DataTable from '../../components/shared/DataTable/DataTable';

const TokensList = ({ 
  tokens = [], 
  loading = false, 
  onRevoke,
  onAdd,
  emptyStateButtonRef
}) => {
  // <prefix>…<suffix> matches the ENV tab's masking shape — every PAT
  // starts with `zby_pat_`, so prefix alone is useless for distinguishing
  // two of them. The suffix (last 6 chars) is the visually-meaningful bit.
  // Pre-2026-05-30 rows don't have suffix yet; fall back to prefix-only
  // for those so they don't render `<prefix>…` (looks like a bug).
  const maskToken = ({ prefix, suffix }) => {
    if (!prefix) return '—';
    if (suffix) return `${prefix}…${suffix}`;
    return `${prefix}…`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const columns = [
    {
      header: 'NAME',
      key: 'name',
      className: 'data-table-name',
      render: (token) => token.name
    },
    {
      header: 'TOKEN',
      key: 'tokenPrefix',
      className: 'data-table-token',
      render: (token) => (
        <span className="token-copyable" title="Token prefix and suffix">
          <span className="token-text">
            {maskToken({ prefix: token.tokenPrefix, suffix: token.tokenSuffix })}
          </span>
        </span>
      )
    },
    {
      header: 'CREATED',
      key: 'createdAt',
      className: 'data-table-date',
      render: (token) => formatDate(token.createdAt)
    },
    {
      // The backend stamps lastUsedAt (fire-and-forget) on every successful
      // PAT validation and the list endpoint returns it — mirrors the
      // self-host tokens table. "—" = never used (or a pre-tracking row).
      header: 'LAST USED',
      key: 'lastUsedAt',
      className: 'data-table-date',
      render: (token) => (
        <span title={token.lastUsedAt || 'never used'}>{formatDate(token.lastUsedAt)}</span>
      )
    }
  ];

  const actions = [
    {
      label: 'Revoke',
      icon: trashOutline,
      onClick: onRevoke,
      danger: true
    }
  ];

  return (
    <DataTable
      data={tokens}
      columns={columns}
      loading={loading}
      rowKey="tokenId"
      actions={actions}
      emptyState={{
        title: "No Tokens Yet",
        description: "Generate your first token to get started with CI/CD integration.",
        actionLabel: "Generate",
        onAction: onAdd,
        buttonRef: emptyStateButtonRef
      }}
    />
  );
};

export default TokensList;
